<script setup>
// Vue
import { defineProps, onBeforeMount, onMounted, ref } from "vue";

import { useIconCache } from "../hooks/iconCache";

// Props
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
});
const { setImageToCache, getImageFromCache } = useIconCache();

// Hooks
onBeforeMount(() => {
  setImageToCache(props.name);
});

onMounted(() => {
  getImageFromCache(props.name, icon);
});

// Data
const icon = ref(null);

// Methods
</script>

<template>
  <i ref="icon" class="icon" />
</template>

<style lang="scss" scoped>
.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
